const enableInlineTabs = () => {
    document.querySelectorAll('.inline-tabs').forEach((container) => {
        const tabs = container.querySelectorAll(':scope > nav li.tabs__tab');
        const panels = container.querySelectorAll(':scope > div.tabs__panel');

        tabs.forEach((tab, tabIdx) => {
            tab.addEventListener('click', (e) => {
                tabs.forEach((el) => {
                    el.classList.toggle('-active', el === e.currentTarget);
                });
                panels.forEach((panel, panelIdx) => {
                    panel.classList.toggle('-active', tabIdx === panelIdx);
                });
            });
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableInlineTabs);
} else {
    enableInlineTabs();
}
